import {
  defaultSettings,
  settingBoolean,
  settingNumber,
  type SettingKey,
  type SettingValues,
} from '@shared/settings';

/**
 * The tuning values the browser is allowed to know.
 *
 * Not a store: the analytics queue reads these from module scope, outside any component, and a
 * hook there would mean threading React through a batching timer. This is a plain mutable record
 * seeded with the compiled defaults, so **nothing waits on the fetch**. The values arrive on the
 * locations response and replace the defaults in place; anything already rendered keeps the
 * default until it next reads, which for a scroll runway or a batch size is invisible.
 *
 * `PRIORITY_CARDS` (`components/PagedGrid.tsx`) and `PRIORITY_CITIES` (`pages/Home.tsx`) are
 * deliberately not among them. Each decides `fetchpriority` on the first paint of its own page —
 * the feed, the homepage — so a fetched value would always arrive after the LCP it exists to
 * tune. A setting that could never do its job is worse than a constant, because it looks like it
 * works.
 */
let values: SettingValues = defaultSettings();

export function applySettings(incoming: Record<string, number | boolean> | undefined): void {
  if (!incoming) return;
  values = { ...values, ...(incoming as Partial<SettingValues>) };
}

export const setting = (key: SettingKey): number => settingNumber(values, key);

/** The on/off switches: registration open, sharing allowed, and the rest of the punter flags. */
export const settingOn = (key: SettingKey): boolean => settingBoolean(values, key);
